import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { auth } from '../firebase';

const Navbar = () => {
  const [user, setUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      setUser(user);
      if (user) {
        try {
          const token = await user.getIdToken();
          const response = await fetch('/api/userProfile', {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          const data = await response.json();
          setUserProfile(data);
        } catch (err) {
          console.error('Chyba při načítání profilu:', err);
        }
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <nav className="bg-gray-900 border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="text-xl sm:text-2xl font-bold bg-gradient-to-r 
                                  from-blue-500 to-purple-600 bg-clip-text text-transparent">
              AMA-Europe
            </Link>
          </div>
          
          {/* Hamburger menu pro mobilní zařízení */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-300 hover:text-white p-2"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>

          {/* Desktop menu */}
          <div className="hidden md:flex md:items-center md:space-x-6">
            <Link to="/" className="text-gray-300 hover:text-blue-400 transition-colors">
              Domů
            </Link>
            <Link to="/auctions" className="text-gray-300 hover:text-blue-400 transition-colors">
              Aukce
            </Link>
            {user && (
              <Link to="/my-account" className="text-gray-300 hover:text-blue-400 transition-colors">
                Můj účet
              </Link>
            )}
            
            {user && userProfile?.role === 'admin' && (
              <Link 
                to="/pridat-auto" 
                className="bg-purple-600 text-white px-4 py-2 rounded-lg
                         hover:bg-purple-700 transition-colors"
              >
                Přidat auto
              </Link>
            )}
            
            {user ? (
              <div className="flex items-center space-x-4">
                <span className="text-gray-300 hidden lg:inline">{user.email}</span>
                <button 
                  onClick={() => auth.signOut()}
                  className="bg-red-600 text-white px-4 py-2 rounded-lg
                           hover:bg-red-700 transition-colors"
                >
                  Odhlásit
                </button>
              </div>
            ) : (
              <Link 
                to="/auth"
                className="bg-blue-600 text-white px-6 py-2 rounded-lg
                         hover:bg-blue-700 transition-colors"
              >
                Přihlásit
              </Link>
            )}
          </div>
        </div>

        {/* Mobilní menu */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <Link 
                to="/" 
                className="block text-gray-300 hover:text-blue-400 transition-colors py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Domů
              </Link>
              <Link 
                to="/auctions" 
                className="block text-gray-300 hover:text-blue-400 transition-colors py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Aukce
              </Link>
              {user && (
                <Link 
                  to="/my-account" 
                  className="block text-gray-300 hover:text-blue-400 transition-colors py-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Můj účet
                </Link>
              )}
              {user && userProfile?.role === 'admin' && (
                <Link 
                  to="/pridat-auto" 
                  className="block text-gray-300 hover:text-blue-400 transition-colors py-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Přidat auto
                </Link>
              )}
              {user ? (
                <>
                  <div className="text-gray-300 py-2">{user.email}</div>
                  <button 
                    onClick={() => {
                      auth.signOut();
                      setIsMenuOpen(false);
                    }}
                    className="w-full text-left text-red-400 hover:text-red-300 transition-colors py-2"
                  >
                    Odhlásit se
                  </button>
                </>
              ) : (
                <Link 
                  to="/auth"
                  className="block text-blue-400 hover:text-blue-300 transition-colors py-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Přihlásit se
                </Link>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;

